import type {
  OrgProjectContextOption,
  OrgProjectFallbackContext,
} from "@arcadeai/ui-kit/org-project-context/types";
import { getRouteApi } from "@tanstack/react-router";

export type OrgProjectContext = OrgProjectFallbackContext;

export type ValidatedOrgProjectContext = OrgProjectContext & {
  organizations: OrgProjectContextOption[];
  projects: OrgProjectContextOption[];
};

export type UseOrgProjectContextResult = {
  organizations: OrgProjectContextOption[];
  projects: OrgProjectContextOption[];
  activeOrganization: OrgProjectContextOption | null;
  activeProject: OrgProjectContextOption | null;
  activeOrganizationId: string | null;
  activeProjectId: string | null;
  isLoadingOrganizations: boolean;
  isLoadingProjects: boolean;
  isReady: boolean;
  isError: boolean;
};

const ORG_PROJECT_ROUTE_ID =
  "/_authenticated/orgs/$organizationId/projects/$projectId";

export const ORG_PROJECT_ROUTE_PATH =
  "/orgs/$organizationId/projects/$projectId" as const;

export const orgProjectRouteApi = getRouteApi(ORG_PROJECT_ROUTE_ID);

const DASHBOARD_HOME_SUFFIX = "/home";

export function buildOrgProjectPath(
  pathnameSuffix: string,
  scope: OrgProjectContext
): `/${string}` {
  const normalizedSuffix =
    pathnameSuffix === "/" ? DASHBOARD_HOME_SUFFIX : pathnameSuffix;
  const suffix = normalizedSuffix.startsWith("/")
    ? normalizedSuffix
    : `/${normalizedSuffix}`;

  return `/orgs/${scope.organizationId}/projects/${scope.projectId}${suffix}`;
}

export function getOrgProjectPathSuffix(
  pathname: string,
  scope: OrgProjectContext
): string {
  const currentPrefix = `/orgs/${scope.organizationId}/projects/${scope.projectId}`;

  if (!pathname.startsWith(currentPrefix)) {
    return DASHBOARD_HOME_SUFFIX;
  }

  const pathnameSuffix = pathname.slice(currentPrefix.length);
  return pathnameSuffix || DASHBOARD_HOME_SUFFIX;
}

// biome-ignore lint/performance/noBarrelFile: backward-compatible re-export from shared library
export { OrgProjectRouteError } from "@arcadeai/ui-kit/org-project-context/types";
